import * as CognitoConfig from "./CognitoConfig";
export const fromGql = (item) => ({
    cognito: item.cognito ? CognitoConfig.fromGql(item.cognito) : undefined,
});
//# sourceMappingURL=VPConfig.js.map